const statuses = {
  provisioning: { label: 'Provisioning', value: 'provisioning'},
  live: { label: 'Live', value: 'live'},
  decommissioning: { label: 'Decommissioning', value: 'decommissioning'},
  decommisioned: { label: 'Decommissioned', value: 'decommissioned'},
  unknown: { label: 'Unknown', value: 'unknown'},
  decommisioned_online: { label: 'Decommissioned Online', value: 'decommissioned_online'}
}

const assetOptions = asset => {
  let options = []

  const currentStatus = asset.status.toLowerCase()
  const currentStatusOption = Object.values(statuses).find(({ label }) => label == currentStatus)

  if (asset.isCreatedManually) { 
    options = Object.values(statuses)
  } else if (asset.isCreatedAutomatically && asset.isOutOfDate) {
    options = [currentStatusOption, statuses.decommissioned]
  } else if (asset.isCreatedAutomatically && currentStatus === 'provisioning') {
    options = [statuses.provisioning, statuses.live]
  } else if (automatedAssetNotOutOfDate(asset) && currentStatus === 'live') {
    options = [statuses.provisioning, statuses.live, statuses.decommissioning]
  } else if (automatedAssetNotOutOfDate(asset) && currentStatus === 'decommissioned') {
    options = [statuses.live, statuses.decommissioning, statuses.decommissioned]
  } else {
    options = [currentStatusOption, statuses.unknown]
  }

  options = [...new Set(options.filter(option => option))]

  return options
}

function automatedAssetNotOutOfDate(asset) {
  return asset.isCreatedAutomatically && !asset.isOutOfDate
}

export default assetOptions
